var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.75 5.75a2 2 0 0 1 2-2h.5a2 2 0 0 1 2 2v12.5a2 2 0 0 1-2 2h-.5a2 2 0 0 1-2-2V5.75ZM14.75 5.75a2 2 0 0 1 2-2h.5a2 2 0 0 1 2 2v12.5a2 2 0 0 1-2 2h-.5a2 2 0 0 1-2-2V5.75Z"
  })));
};
export default SvgPause;